import { __assign, __extends } from "tslib";
// DS: CR16
import React from 'react';
import { Url, URLS } from '@wix/da-url';
import { withTranslation } from 'react-i18next';
import { ModalType } from '../../../Modals/redux/types';
import ListMenu from '../../../Dropdown/Preset/ListMenu';
import classnames from 'classnames';
import { BiEventType, ReferralType, BiLink, BiSpan, BiButton, } from '../../../biLogger';
import HoverComponent from '../../_partials/HoverComponent/HoverComponent';
import { withVerification, } from '../../../VerificationPopup/withVerification';
import SubmitButton from './SubmitButton';
import { withFeatureFlags } from '../../../redux/flags';
import s from './SubmitMenu.scss';
var configHoverComponent = function (translate, svg) { return ({
    componentHover: {
        svg: svg,
        title: translate + ".title",
        context: translate + ".context",
    },
}); };
var SubmitMenu = /** @class */ (function (_super) {
    __extends(SubmitMenu, _super);
    function SubmitMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.submitMenuItems = [
            __assign({ label: 'siteHeader.deviation', link: URLS.SUBMIT, componentClass: BiLink, componentProps: {
                    biData: {
                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                        menu_item: 'deviation',
                        menu_name: 'submit',
                        link_url: URLS.SUBMIT,
                    },
                } }, configHoverComponent('siteHeader.deviation', 'deviant')),
            __assign(__assign({ label: 'siteHeader.statusUpdate', verificationAction: 'submitstatus' }, _this.getItemProps(ModalType.STATUS_UPDATE)), configHoverComponent('siteHeader.statusUpdate', 'status')),
            __assign(__assign({ label: 'siteHeader.journal', verificationAction: 'submitjournal' }, _this.getItemProps(ModalType.JOURNAL)), configHoverComponent('siteHeader.journal', 'journal')),
            __assign(__assign({ label: 'siteHeader.literature' }, _this.getItemProps(ModalType.LITERATURE)), configHoverComponent('siteHeader.literature', 'literature')),
            __assign(__assign({ label: 'siteHeader.commission', verificationAction: 'submitcommission' }, _this.getItemProps(ModalType.COMMISSION, {
                params: { redirectOnSubmit: true },
            })), configHoverComponent('siteHeader.commission', 'commission')),
            __assign(__assign({ label: 'siteHeader.poll', verificationAction: 'submitpoll' }, _this.getItemProps(ModalType.POLL_EDIT)), configHoverComponent('siteHeader.poll', 'poll')),
            __assign({ label: 'siteHeader.daMuro', link: Url.buildFromPath(URLS.SUBMIT_MURO), target: '_blank', componentClass: BiLink, componentProps: {
                    biData: {
                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                        menu_item: 'da_muro',
                        menu_name: 'submit',
                        link_url: Url.buildFromPath(URLS.SUBMIT_MURO),
                    },
                } }, configHoverComponent('siteHeader.daMuro', 'muro')),
        ];
        _this.getMenuItem = function (_a) {
            var label = _a.label, onClick = _a.onClick, target = _a.target, componentClass = _a.componentClass, componentProps = _a.componentProps, componentHover = _a.componentHover, _b = _a.verificationAction, verificationAction = _b === void 0 ? 'submit' : _b, link = _a.link;
            var _c = _this.props, t = _c.t, isVerificationNeeded = _c.isVerificationNeeded, pushVerificationPopup = _c.pushVerificationPopup, isLoggedIn = _c.isLoggedIn, restrictLoggedOut = _c.restrictLoggedOut;
            var Component = componentClass || BiSpan;
            var onItemClick = onClick;
            if (!isLoggedIn) {
                onItemClick = function (e) {
                    e.preventDefault();
                    restrictLoggedOut({ restrictedActionName: ReferralType.SUBMIT });
                };
            }
            else if (isVerificationNeeded) {
                // if verification needed, everything is a modal
                onItemClick = function (e) {
                    e.preventDefault();
                    pushVerificationPopup(verificationAction);
                };
            }
            return {
                key: label,
                renderElement: function () { return (React.createElement(Component, __assign({ className: s['submit-menu-item'], href: link, target: target, tabIndex: "0", title: t(label), onClick: onItemClick }, componentProps),
                    t(label),
                    React.createElement(HoverComponent, __assign({}, componentHover, { className: s['hover-component'] })))); },
            };
        };
        return _this;
    }
    SubmitMenu.prototype.getItemProps = function (type, options) {
        var _a;
        var _b = this.props, isLegacyHeader = _b.isLegacyHeader, showSubmitModal = _b.showSubmitModal;
        var types = (_a = {},
            _a[ModalType.STATUS_UPDATE] = 'status',
            _a[ModalType.JOURNAL] = 'journal',
            _a[ModalType.LITERATURE] = 'literature',
            _a[ModalType.POLL_EDIT] = 'poll',
            _a[ModalType.COMMISSION] = 'commission',
            _a);
        var biData = {
            evid: BiEventType.TOP_NAV_MENU_CLICK,
            menu_item: types[type],
            menu_name: 'submit',
        };
        if (isLegacyHeader) {
            var url = Url.browseHomeLink() + "?submit_modal=" + types[type];
            return {
                link: url,
                componentClass: BiLink,
                componentProps: {
                    biData: __assign({ link_url: url }, biData),
                },
            };
        }
        return {
            onClick: function () { return showSubmitModal(type, options); },
            componentClass: BiButton,
            componentProps: { biData: biData },
        };
    };
    SubmitMenu.prototype.render = function () {
        var _a = this.props, className = _a.className, menuClassName = _a.menuClassName, t = _a.t, isOpen = _a.isOpen, toggleSubmitMenu = _a.toggleSubmitMenu;
        var items = this.submitMenuItems;
        return (React.createElement("div", { className: classnames(s['submit-dropdown'], className) },
            React.createElement("div", { className: s['submit-button-link-wrapper'] },
                React.createElement(SubmitButton, { className: classnames(s['submit-button'], isOpen && s['submit-button-open']), isOpen: isOpen, onClick: toggleSubmitMenu, id: "site-header-submit-button", "aria-controls": "site-header-submit-menu" }, t('siteHeader.submit'))),
            React.createElement("div", { role: "menu", id: "site-header-submit-menu", "aria-labelledby": "site-header-submit-button", className: s['submit-menu-wrapper'], "aria-hidden": !isOpen },
                React.createElement(ListMenu, { className: classnames(menuClassName, s['submit-menu']), items: items.map(this.getMenuItem) }))));
    };
    return SubmitMenu;
}(React.Component));
export default withVerification(withTranslation()(withFeatureFlags(SubmitMenu)));
//# sourceMappingURL=SubmitMenu.js.map